
import { useParams } from "react-router-dom";
import { SidebarProvider } from "@/components/ui/sidebar";
import { AdminSidebar } from "@/components/AdminSidebar";
import { StatsCards } from "./transaction-history/components/StatsCards";
import { TransactionsTable } from "./transaction-history/components/TransactionsTable";
import { useTransactionHistory } from "./transaction-history/hooks/useTransactionHistory";

const TransactionHistory = () => {
  const { schoolId } = useParams();
  const { bills, loading, stats, schoolName } = useTransactionHistory(schoolId || '');

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full bg-gray-100">
        <AdminSidebar />
        <div className="flex-1">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="mb-12">
              <h1 className="text-4xl font-bold" style={{ color: "#008169" }}>
                Transaction History
              </h1>
              <p className="text-xl text-gray-600 mt-2">
                {schoolName}
              </p>
            </div>

            <StatsCards stats={stats} />
            <TransactionsTable bills={bills} loading={loading} />
          </div>
        </div>
      </div>
    </SidebarProvider>
  );
};

export default TransactionHistory;
